import { t } from "i18next";
import { useContext } from "react";
import FilterableTableLayout from "../../components/FilterableTableLayout/FilterableTableLayout";
import { ModalsContext } from "../../context/modals.context";
import { PersistedFilterKeys } from "../../modules/filters/filters.types";
import {
  getMonitoringListFilterItems,
  getMonitoringTableColumns,
  MONITORING_LIST_INITIAL_FILTERS,
  MONITORING_LIST_INITIAL_PAGINATION,
} from "../../modules/trackAndTrace/trackAndTrace.constants";
import { useMonitoringList } from "../../modules/trackAndTrace/trackAndTrace.queries";
import {
  Monitoring,
  MonitoringListFilterPayload,
  MonitoringListResponse,
} from "../../modules/trackAndTrace/trackAndTrace.types";
import MonitoringDetailsModal from "./components/MonitoringDetailsModal/MonitoringDetailsModal";

const MonitoringPage = () => {
  const { handleUpdateModals } = useContext(ModalsContext);

  const onDetailClickHandler = (id: number) => {
    handleUpdateModals({
      modalVisible: "monitoringDetailsModal",
      id,
    });
  };

  return (
    <>
      <MonitoringDetailsModal />
      <FilterableTableLayout<
        Monitoring,
        MonitoringListResponse,
        MonitoringListFilterPayload
      >
        tableName="monitoring_table"
        toolbarId="monitoring_list"
        title={t("TRACK.MONITORING")}
        getTableColumns={() =>
          getMonitoringTableColumns({ onDetailClickHandler })
        }
        queryHook={useMonitoringList}
        tableRowKey="id"
        onTableRowClick={(record: Monitoring) =>
          onDetailClickHandler(record?.id)
        }
        filterProps={{
          getFilterItems: getMonitoringListFilterItems,
          initialFilters: MONITORING_LIST_INITIAL_FILTERS,
          persistedFilterKey: PersistedFilterKeys.MONITORING_LIST,
        }}
        dataListKey="list"
        paginationProps={{
          enableAPIPagination: true,
          initialPagination: MONITORING_LIST_INITIAL_PAGINATION,
          totalCountKey: "total",
        }}
      />
    </>
  );
};

export default MonitoringPage;
